import { Flex, Layout } from "antd";
import styled from "styled-components";

export const StyledFlex = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  height: 2rem;
  background-color: transparent;
`;

export const HeaderHeadline = styled.h1`
  font-size: 36px;
  font-weight: bold;
  font-family: "Alef", sans-serif;
`;

export const FilterButtonWrapper = styled.div`
  direction: ltr;
`;

export const StyledAddStep = styled(Flex)`
  cursor: pointer;
  width: fit-content;
  width: 100%;
`;

export const StyledInstructionsNumber = styled(Flex).attrs({
  justify: "center",
  align: "center",
})`
  color: white;
  background-color: #94a5f2;
  border-radius: 50%;
  border: 2px solid #f5f6f7;
  height: 34px;
  width: 34px;
  box-shadow: 0px 2px 5px 0px #26334d08;
`;

export const StepsWrapper = styled(Flex)`
  width: 50%;
  margin-top: 20px;
`;
